export default __webpack_public_path__ + "static/media/information--shared-path-vehicles-and-motorcycles--g1.50a9ff18.png";